import { Controller } from "@hotwired/stimulus";

function fmt(ms) {
  if (ms < 0) ms = 0;
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h${m < 10 ? "0" : ""}${m}m${sec < 10 ? "0" : ""}${sec}s`;
  if (m > 0) return `${m}m${sec < 10 ? "0" : ""}${sec}s`;
  return `${sec}s`;
}

// Renders per-cell durations. Each cell carries `data-elapsed-ms` (the
// initial offset at render time) and optionally `data-status`. When
// data-status is anything other than "running" the cell renders its
// frozen duration once and isn't re-ticked — useful for tables that
// mix in-flight and historical rows.
export default class extends Controller {
  static targets = ["cell"];

  connect() {
    this.loadedAt = Date.now();
    this.bases = this.cellTargets.map((n) => parseInt(n.dataset.elapsedMs, 10) || 0);
    this.statuses = this.cellTargets.map((n) => n.dataset.status || "running");
    this.tick();
    if (this.statuses.some((s) => s === "running")) {
      this.interval = setInterval(() => this.tick(), 1000);
    }
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const now = Date.now();
    this.cellTargets.forEach((n, i) => {
      const base = this.bases[i];
      if (this.statuses[i] === "running") {
        n.textContent = fmt(base + (now - this.loadedAt));
      } else {
        n.textContent = fmt(base);
      }
    });
  }
}
